export const BRAND = {
  name: "Knight Media Group",
  phone: "1 (513) 840-4087",
  phoneHref: "tel:+15138404087",
  fax: "1 (513) 399-4989",
  faxHref: "tel:+15133994989",
  email: "damon.knight@knightmediagroup.com",
  address: "8465 Colerain Ave., Cincinnati, Ohio 45239",
  bookMeetingUrl: "https://knight-media-group.ninjapipe.app/book/knight-media-group-consultation",
  clientPortalUrl: "https://knight-media-group.ninjapipe.app/client-portal/login",
  logoUrl: "/assets/kmg-header-logo.png",
  heroBg: "/assets/hero-bg.jpg",
  // Optional: drop a 10-15s MP4 URL here to enable the hero video background.
  // Leave empty to use heroBg image fallback.
  heroVideo: "",
  socials: {
    instagram: "https://instagram.com/",
    threads:
      "https://www.threads.com/@knightmediagroup06?igshid=NTc4MTIwNjQ2YQ==",
    facebook: "https://facebook.com/",
    x: "https://x.com/",
    tiktok: "https://tiktok.com/",
    youtube: "https://youtube.com/",
  },
};

export const STATS = [
  { value: 40, suffix: "+", label: "Brands Served" },
  { value: 150, suffix: "+", label: "Campaigns Launched" },
  { value: 62, suffix: "%", label: "Avg. Engagement Lift" },
  { value: 2, suffix: "M+", label: "Monthly Reach" },
];


const J3A = "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts";
const KMW = "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts";

export const SERVICES = [
  {
    title: "Social Media Management",
    desc: "Daily posting, community management, and growth strategy across every major platform — handled end to end.",
    icon: "Megaphone",
    image: "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?auto=format&fit=crop&w=900&q=80",
    included: [
      "Custom monthly content calendar",
      "Daily posting & community management",
      "Platform growth strategy (IG, TikTok, FB, LinkedIn)",
      "Monthly performance reporting",
    ],
    samples: [
      `${J3A}/33gpdx1p_7595EFF6-6D48-44D5-9590-8694F6304AA2.png`,
      `${J3A}/ea89o7zk_DA52E89C-4771-4052-99A1-BE27B69D2EF2.png`,
      `${J3A}/0jaz2fwo_B8618E8D-71F6-4928-B26E-0C095F12F5B9.png`,
    ],
  },
  {
    title: "Content Creation",
    desc: "Scroll-stopping reels, photography, and graphics tailored to your brand voice and audience.",
    icon: "Clapperboard",
    image: "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf?auto=format&fit=crop&w=900&q=80",
    included: [
      "Short-form reels & video editing",
      "Branded photography sessions",
      "Custom graphics & carousels",
      "Hook & caption copywriting",
    ],
    samples: [
      `${KMW}/i5c3t2hv_NNLCover1png.png`,
      `${J3A}/33gpdx1p_7595EFF6-6D48-44D5-9590-8694F6304AA2.png`,
      `${J3A}/ea89o7zk_DA52E89C-4771-4052-99A1-BE27B69D2EF2.png`,
    ],
  },
  {
    title: "Brand Strategy",
    desc: "Positioning, messaging, and visual identity systems engineered to win in your category.",
    icon: "Target",
    image: "https://images.unsplash.com/photo-1758876022363-542ba727f641?auto=format&fit=crop&w=900&q=80",
    included: [
      "Brand audit & competitive positioning",
      "Messaging & voice framework",
      "Visual identity direction",
      "Quarterly growth playbook",
    ],
    samples: [
      `${KMW}/clmjh9g5_background_removed_image_0d8hVtkPTGakFH2ORr8FYA.png`,
      `${J3A}/93zmmja3_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_30_38%20AM.png`,
      `${J3A}/ebgm0zr7_20BA7ABF-076B-4A75-814C-71D2AFC4BDB8.png`,
    ],
  },
  {
    title: "Logo Design",
    desc: "Distinctive, ownable marks and full identity kits — from concept to brand guidelines.",
    icon: "PenTool",
    image: "https://images.unsplash.com/photo-1611241893603-3c359704e0ee?auto=format&fit=crop&w=900&q=80",
    included: [
      "Concept exploration & sketches",
      "Primary + secondary logo marks",
      "Color & typography system",
      "Full brand guidelines kit",
    ],
    samples: [
      `${J3A}/ujopc0r7_D571B052-7582-4161-A015-F11C42512B96.png`,
      `${J3A}/zsnpa06a_C4A9A105-0FC0-43DD-971C-1D3B19AE6CBF.png`,
      `${J3A}/xjmpou86_tinywow_FEE09309-5783-4D67-AD6C-EC8B3E91D93A_91075962.png`,
    ],
  },
  {
    title: "Website Design",
    desc: "Conversion-focused, fast, and beautiful sites built on modern stacks with SEO baked in.",
    icon: "Monitor",
    image: "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?auto=format&fit=crop&w=900&q=80",
    included: [
      "Custom responsive design",
      "Conversion-focused copy & layout",
      "SEO best practices baked in",
      "Fast, modern tech stack",
    ],
    samples: [
      "/assets/websites/voltpro-electric.png",
      "/assets/websites/johndoe-hvac.png",
      "/assets/websites/knightins.png",
    ],
  },
  {
    title: "Event Photography",
    desc: "On-site coverage that captures the energy of your brand events, launches, and activations.",
    icon: "Camera",
    image: "https://images.unsplash.com/photo-1623348282113-50395974159c?auto=format&fit=crop&w=900&q=80",
    included: [
      "On-site event coverage",
      "Professional editing & retouching",
      "Fast digital gallery delivery",
      "Social-ready crops & highlights",
    ],
    samples: [
      `${J3A}/m4xcwx66_R6II6273.jpg`,
      `${J3A}/fx22kmjp_R6II6303.jpg`,
      `${J3A}/1fog9ogx_R6II6924.jpg`,
    ],
  },
  {
    title: "Reputation Management",
    desc: "Proactive review monitoring, response strategy, and online sentiment optimization that protects and elevates your brand’s public perception.",
    icon: "ShieldCheck",
    image: "https://images.unsplash.com/photo-1633613286991-611fe299c4be?auto=format&fit=crop&w=900&q=80",
    included: [
      "Review monitoring across platforms",
      "Response strategy & templates",
      "Sentiment tracking & alerts",
      "Reputation recovery plans",
    ],
    samples: [
      "https://images.unsplash.com/photo-1633613286991-611fe299c4be?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    ],
  },
  {
    title: "Analytics & Reporting",
    desc: "Custom dashboards, cohort tracking, and weekly insight digests so you always know which channels are driving revenue and which need to be optimized.",
    icon: "BarChart3",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    included: [
      "Custom KPI dashboards",
      "Weekly insight digests",
      "Channel attribution modeling",
      "Cohort & retention tracking",
    ],
    samples: [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=900&q=80",
    ],
  },
  {
    title: "Paid Analytics Reporting",
    desc: "Granular paid-media attribution across Meta, TikTok, Google, and LinkedIn — ROAS, CAC, and frequency benchmarks delivered in plain English.",
    icon: "LineChart",
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=900&q=80",
    included: [
      "ROAS & CAC benchmarking",
      "Cross-platform attribution",
      "Creative performance breakdown",
      "Plain-English reporting",
    ],
    samples: [
      "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    ],
  },
];

export const TEAM = [
  {
    name: "Damon Knight",
    role: "Agency Principal",
    email: "damon.knight@knightmediagroup.com",
    photo:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/ft95xqeo_IMG_8259.png",
    desc: "Started Knight Media Group with a simple mission — help small business owners win online. Damon takes deep pride in standing shoulder-to-shoulder with founders and watching their brands grow into something they’re proud to own.",
  },
  {
    name: "Brooke Knight",
    role: "Creative Director",
    email: "brooke.knight@knightmediagroup.com",
    photo:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/xk7978n3_BNKHS5.jpeg",
    desc: "Lives for the moment a small business sees its story told the right way for the first time. Brooke leads creative with heart — every reel, photo, and brand system is built to help our clients stand tall in their community.",
  },
  {
    name: "Jessica Wollett",
    role: "Project Manager",
    email: "jessica.wollett@knightmediagroup.com",
    photo:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/1w8z223h_AiOMHS.webp",
    desc: "Treats every small business client like family. Jessica’s the steady hand keeping creative, content, and channel teams in lock-step so our partners feel supported, informed, and confident every step of the way.",
  },
];

export const LOGO_MARQUEE = [
  "Aurora Coffee Co.",
  "Velocity Auto",
  "Northbend Realty",
  "Halcyon Wellness",
  "Riverline Bistro",
  "Crescent Athletics",
  "Beacon Legal",
  "Forge & Anvil",
  "Lumen Salon",
  "Queen City Roofing",
];

const MEDIA = `${process.env.REACT_APP_BACKEND_URL}/api/media`;

const KMG_WORK = [
  {
    title: "Nikki's Next Level — June Wig Sale",
    tag: "Video Reel",
    type: "video",
    video: `${MEDIA}/nnl-june-sale.mp4`,
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/kk3c4qiu_ChatGPT%20Image%20Jun%206%2C%202026%2C%2005_59_33%20AM.png",
  },
  {
    title: "Nikki's Next Level — Brand Film",
    tag: "Video Reel",
    type: "video",
    video: `${MEDIA}/nnl-brand-film.mp4`,
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/desdkzhm_IMG_D2EBA648-A02D-4344-845B-8B5C0446DAB3.jpeg",
  },
  {
    title: "Knight Credit Consultants — Credit Report Review",
    tag: "Video Reel",
    type: "video",
    video: `${MEDIA}/kcc-credit-review.mp4`,
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/2iey76e3_ChatGPT%20Image%20Jun%206%2C%202026%2C%2001_29_52%20AM.png",
  },
  {
    title: "Knight Credit Consultants — 5 Tips to Improve Credit",
    tag: "Video Reel",
    type: "video",
    video: `${MEDIA}/kcc-credit-tips.mp4`,
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/c649drer_recreate-in-3d_a8fPi8UoT-SP1l07vV-Zzg_tipRf-xbQC6DjUZv54vHHg_cover_2k%20%281%29.jpeg",
  },
  {
    title: "Nikki's Next Level — Wig Care Reel",
    tag: "Video Reel",
    type: "video",
    video: `${MEDIA}/nnl-wigcare-reel.mp4`,
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/xblgzr3q_36A97808-A148-4E4C-81E1-A69D07F80101.png",
  },
  {
    title: "Nikki's Next Level — Final Hours 25% Off",
    tag: "Sale Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/esgniju4_80B53AF3-08D7-41B0-A9B2-BC12BEF1F687.png",
  },
  {
    title: "Nikki's Next Level — Self-Care Slay Sale",
    tag: "Sale Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/xblgzr3q_36A97808-A148-4E4C-81E1-A69D07F80101.png",
  },
  {
    title: "Grades Plus Game — 3v3 Tournament",
    tag: "Event Flyer",
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/xkatofy8_MASTER_RECREATION_ENHANCEMENT__Nano_Banana_2_77242.jpeg",
  },
  {
    title: "Nikki's Next Level — Imperial Luxe Reel",
    tag: "Video Reel",
    type: "video",
    video:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/t9za9nrz_168C5202-057A-4867-81D8-EC2867657CC6.mp4",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/kk3c4qiu_ChatGPT%20Image%20Jun%206%2C%202026%2C%2005_59_33%20AM.png",
  },
  {
    title: "Knight Credit Consultants — The Cost of Bad Credit",
    tag: "Infographic",
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/c649drer_recreate-in-3d_a8fPi8UoT-SP1l07vV-Zzg_tipRf-xbQC6DjUZv54vHHg_cover_2k%20%281%29.jpeg",
  },
  {
    title: "Knight Insurance Solutions — Stop Overpaying",
    tag: "Insurance Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_3a60f548-c5b2-42d1-8621-c1256f564833/artifacts/jrp1na89_7D88C0B6-2E38-4D25-A7C0-DEE261BC5C99.png",
  },
  {
    title: "Knight Credit Consultants — A Better Credit Future",
    tag: "Brand Flyer",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/2iey76e3_ChatGPT%20Image%20Jun%206%2C%202026%2C%2001_29_52%20AM.png",
  },
  {
    title: "Nikki's Next Level — Imperial Luxe & Silk Dynasty",
    tag: "Product Launch",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/kk3c4qiu_ChatGPT%20Image%20Jun%206%2C%202026%2C%2005_59_33%20AM.png",
  },
  {
    title: "Knight Insurance Solutions — Teen Driver Liability",
    tag: "Insurance Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/fisn59nc_A1D060AD-08B1-4A44-8519-7FE44BE2DD25.png",
  },
  {
    title: "Club Nip CS — 90's Throwback Party",
    tag: "Event Promo",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/69g7f979_openart-image_1779750991433_7932a73a_1779750991944_df1774ef%20%281%29.jpeg",
  },
  {
    title: "Knight Media Group — Social Media Management",
    tag: "Service Promo",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/k02ab5xd_3BE597A5-D1C2-42F7-B35A-8CAACB74A475.png",
  },
  {
    title: "Nikki's Next Level — Premium Bundle Drop",
    tag: "Beauty Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/desdkzhm_IMG_D2EBA648-A02D-4344-845B-8B5C0446DAB3.jpeg",
  },
  {
    title: "DJ NIP — Artist Brand Identity",
    tag: "Artist Branding",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/r40adcjf_A3FA2E24-3CF4-4FB6-A7E6-9BC3F06D09B6.jpeg",
  },
  {
    title: "Knight Insurance — Protect Your Valuables Infographic",
    tag: "Insurance Campaign",
    image:
      "https://customer-assets.emergentagent.com/job_knight-media-web/artifacts/lhpd3awc_12001010-5756-4211-A134-45EE1A24D7B1.png",
  },
];

const STOCK_WORK = [
  ["Skyline Realty — Drone Shoot", "Video"],
  ["Vector Tech — Investor Deck", "Strategy"],
  ["Olive & Oak — Spring Drop", "Campaign"],
  ["Pulse Fitness — 30-Day Sprint", "Performance"],
  ["Cobalt Studios — Site Build", "Web"],
  ["Aurora Coffee — Brand Refresh", "Branding"],
  ["Velocity Auto — Launch Campaign", "Paid Social"],
  ["Northbend Realty — Listings Engine", "Web Design"],
  ["Halcyon Wellness — Identity System", "Identity"],
];

const STOCK_IMAGES = [
  "https://images.pexels.com/photos/106344/pexels-photo-106344.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1764303017700-8bcf9c71abcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMG5lb24lMjBnZW9tZXRyaWMlMjBzaGFwZXN8ZW58MHx8fHwxNzc3MjQ1ODc2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1759922222223-1e4b477530ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG5lb24lMjBnZW9tZXRyaWMlMjBzaGFwZXN8ZW58MHx8fHwxNzc3MjQ1ODc2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/32396570/pexels-photo-32396570.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1686061593213-98dad7c599b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc3NzI0NTg3Nnww&ixlib=rb-4.1.0&q=85",
];

export const PORTFOLIO = [
  ...KMG_WORK,
  ...STOCK_WORK.map(([title, tag], i) => ({
    title,
    tag,
    image: STOCK_IMAGES[i % STOCK_IMAGES.length],
  })),
].slice(0, 15);

export const CASE_STUDIES = [
  {
    client: "Aurora Coffee Co.",
    industry: "Hospitality · Retail",
    headline: "+38% weekend foot traffic in 60 days.",
    metrics: { engagement: "+62%", followers: "+220/mo", reach: "84k/mo" },
    image:
      "https://images.pexels.com/photos/12570668/pexels-photo-12570668.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Velocity Auto",
    industry: "Automotive",
    headline: "Tripled qualified leads from paid social.",
    metrics: { engagement: "+58%", followers: "+340/mo", reach: "112k/mo" },
    image:
      "https://images.pexels.com/photos/16176576/pexels-photo-16176576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Northbend Realty",
    industry: "Real Estate",
    headline: "Listings engine that books showings on autopilot.",
    metrics: { engagement: "+47%", followers: "+165/mo", reach: "63k/mo" },
    image:
      "https://images.pexels.com/photos/30580640/pexels-photo-30580640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Halcyon Wellness",
    industry: "Health & Wellness",
    headline: "Brand system + site rebuild flooded bookings.",
    metrics: { engagement: "+74%", followers: "+290/mo", reach: "96k/mo" },
    image:
      "https://images.pexels.com/photos/3757942/pexels-photo-3757942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Riverline Bistro",
    industry: "Restaurant",
    headline: "Reels-led reservations became their #1 channel.",
    metrics: { engagement: "+89%", followers: "+410/mo", reach: "138k/mo" },
    image:
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=940&q=80",
  },
  {
    client: "Crescent Athletics",
    industry: "Sports & Fitness",
    headline: "Launch hype reel hit 4.1M organic views.",
    metrics: { engagement: "+118%", followers: "+625/mo", reach: "186k/mo" },
    image:
      "https://images.pexels.com/photos/13106575/pexels-photo-13106575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Beacon Legal",
    industry: "Professional Services",
    headline: "SEO + content engine pulled page-one rankings.",
    metrics: { engagement: "+34%", followers: "+95/mo", reach: "42k/mo" },
    image:
      "https://images.pexels.com/photos/6077665/pexels-photo-6077665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    client: "Queen City Roofing",
    industry: "Home Services",
    headline: "Full-funnel lead system dropped cost per lead 62%.",
    metrics: { engagement: "+41%", followers: "+135/mo", reach: "58k/mo" },
    image:
      "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?auto=format&fit=crop&w=940&q=80",
  },
  {
    client: "Lumen Salon",
    industry: "Beauty",
    headline: "Photo + social refresh booked them out for months.",
    metrics: { engagement: "+66%", followers: "+245/mo", reach: "78k/mo" },
    image:
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=940&q=80",
  },
];

export const TESTIMONIALS = [
  {
    authorName: "Marcus Reyes",
    authorTitle: "Owner, Aurora Coffee Co.",
    avatarUrl: "https://i.pravatar.cc/150?img=12",
    rating: 5,
    quote:
      "Knight Media Group rebuilt our entire social presence in 60 days. Foot traffic on weekends is up 38% and we've never looked sharper.",
  },
  {
    authorName: "Elena Park",
    authorTitle: "GM, Velocity Auto",
    avatarUrl: "https://i.pravatar.cc/150?img=47",
    rating: 5,
    quote:
      "The team treats our store like it's their own. Lead volume from paid social tripled in one quarter — real numbers, not vanity metrics.",
  },
  {
    authorName: "Devon Hill",
    authorTitle: "Broker, Northbend Realty",
    avatarUrl: "https://i.pravatar.cc/150?img=33",
    rating: 5,
    quote:
      "From listing reels to email funnels, every deliverable has lifted our pipeline. Best investment we've made this year.",
  },
  {
    authorName: "Priya Anand",
    authorTitle: "Founder, Halcyon Wellness",
    avatarUrl: "https://i.pravatar.cc/150?img=44",
    rating: 5,
    quote:
      "They translated our vision into a brand that finally feels like us — and built the website to match. Bookings are flowing.",
  },
  {
    authorName: "Tomás Rivera",
    authorTitle: "Owner, Riverline Bistro",
    avatarUrl: "https://i.pravatar.cc/150?img=15",
    rating: 4,
    quote:
      "Our reels actually reach people now. Reservations from Instagram have become a real channel for the restaurant.",
  },
  {
    authorName: "Sienna Brooks",
    authorTitle: "Director, Crescent Athletics",
    avatarUrl: "https://i.pravatar.cc/150?img=49",
    rating: 5,
    quote:
      "Strategy, creative, and execution under one roof. Communication is fast, the work is sharp, and the results speak for themselves.",
  },
  {
    authorName: "Reggie Tanaka",
    authorTitle: "Event Lead, Vanguard Live",
    avatarUrl: "https://i.pravatar.cc/150?img=68",
    rating: 5,
    quote:
      "Their event photography crew captured our launch night perfectly — sharp, candid, and on-brand. We had publish-ready galleries before guests even got home.",
  },
  {
    authorName: "Camila Rivers",
    authorTitle: "Founder, Olive & Oak",
    avatarUrl: "https://i.pravatar.cc/150?img=23",
    rating: 5,
    quote:
      "KMG runs our entire social media — content calendar, posting, DMs, the works. Engagement is up 4x and we finally feel like a brand people follow on purpose.",
  },
  {
    authorName: "Andre Whitaker",
    authorTitle: "Owner, Forge & Anvil",
    avatarUrl: "https://i.pravatar.cc/150?img=52",
    rating: 5,
    quote:
      "Handing social media management to Knight Media Group was the smartest move we made. Daily posts, community engagement, and growth — all just handled.",
  },
];
